import { injectable } from "inversify";
import AIRepository from "../../repositories/AIRepository";

interface props {
    aiRepository: AIRepository;
}

@injectable()
export class UpdateAISummaryByRecordingUseCase {
    _aiRepository: AIRepository;

    constructor(_: props) {
        this._aiRepository = _.aiRepository;
    }

    public call = async (record: string, content: any, channel: string): Promise<any> => {
        return await this._aiRepository.updateAISumaryByRecord(record, content, channel);
    }
}

export const UpdateAISummaryByRecordingUseCaseName = "UpdateAISummaryByRecordingUseCaseName";